import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Path-based routing (not the hash router the main app uses): share links are
// plain URLs like https://presenter.nuway.co/s/<token>, so the container serving
// this build must fall back to index.html for unknown paths — see nginx.conf.
const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
